export const MAGIC_LINK_TOKEN_COOKIE_NAME = 'mlt'
export const ACCOUNT_SESSION_TOKEN_COOKIE_NAME = 'PulseSessionToken'
